import { styled } from '@mui/material/styles';
import { Button, FormControl, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

export const CancelButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(3),
  color: theme.palette.red.main,
  borderColor: theme.palette.red.main,
  '&:hover': {
    borderColor: theme.palette.red.main
  }
}));

export const SaveButton = styled(LoadingButton)(({ theme }) => ({
  marginRight: theme.spacing(3)
}));

export const ChangeEmailButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(3),
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  width: '10rem',
  height: '40px'
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%'
}));

export const ErrorTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1)
}));

export const DialogCancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.red.main,
  borderColor: theme.palette.red.main,
  '&:hover': {
    borderColor: theme.palette.red.main
  }
})); 